// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__1FOHU","link":"button_link__27Chp"};